import cmp from '../../lib/cmp';
import { mkFileSize } from '../../lib/utils';
import { formatDate } from '../utils/formatDate';
import { isRtl } from '../../lib/document-dir-utils';
import './sm-landing-appstore-app-1-information.less';
import imageLicense from '../../images/landing-appstore/license';
import imageWebsite from '../../images/landing-appstore/website';
import imagePolicy from '../../images/landing-appstore/policy';



const rowTpl = (name, value) => `
  <div class="sm-landing-appstore-app-1-information__item">
    <div class="sm-landing-appstore-app-1-information__item-in">
      <div class="sm-landing-appstore-app-1-information__item-name${isRtl() ? '-rtl' : ''}">${name}</div>
      <div class="sm-landing-appstore-app-1-information__item-value${isRtl() ? '-rtl' : ''}">${value}</div>
    </div>
  </div>
`;

const rowTplAction = (name, icon) => `
  <div class="sm-landing-appstore-app-1-information__item sm-landing-appstore-app-1-information__item--action">
    <div class="sm-landing-appstore-app-1-information__item-in">
      <div class="sm-landing-appstore-app-1-information__item-name${isRtl() ? '-rtl' : ''}">${name}</div>
      <div class="sm-landing-appstore-app-1-information__item-value${isRtl() ? '-rtl' : ''}">${icon}</div>
    </div>
  </div>
`;

const informationView = ($cmp, {
  seller,
  category,
  date_updated,
  file_size,
  content_rating,
  operating_systems,
  apple_watch,
  languages = [],
  license_agreement,
  privacy_policy,
  in_app_purchases,
  developer_website,
  isIPAD
}) => {
  const date_updated_string = date_updated ? formatDate(date_updated) : '';
  const _fileSize = file_size ? mkFileSize(file_size) : file_size;

  const iconLicense = `<div class="sm-landing-appstore-app-1-information__icon">${imageLicense({ color: '#267ff9' })}</div>`;
  const iconWebsite = `<div class="sm-landing-appstore-app-1-information__icon">${imageWebsite({ color: '#267ff9' })}</div>`;
  const iconPolicy = `<div class="sm-landing-appstore-app-1-information__icon">${imagePolicy({ color: '#267ff9' })}</div>`;

  const mkTangText = () => {
    if (languages.length === 1) {
      return languages[0];
    }

    if ((languages.indexOf('en') >= 0) || (languages.indexOf('English') >= 0)) {
      return `${__('sm@_english')} ${__('sm@_and')} ${languages.length - 1} ${__('sm@_more')}`;
    }

    return `${languages[0]} ${__('sm@_and')} ${languages.length - 1} ${__('sm@_more')}`;
  };

  return `
    <div class="sm-landing-appstore-app-1-information">

      <div class="sm-landing-appstore-app-1-information__h">${__('sm@_information')}</div>
      <div class="sm-landing-appstore-app-1-information__list">
        ${seller ? rowTpl(__('sm@_seller'), seller) : ''}
        ${_fileSize ? rowTpl(__('sm@_size'), _fileSize) : ''}
        ${category ? rowTpl(__('sm@_category'), __(category)) : ''}
        ${operating_systems ? rowTpl(__('sm@_compatibility'), `${isIPAD ? __('sm@_works_on_this_iPad') : __('sm@_works_on_this_iPhone')}<span class="sm-landing-appstore-app-1-information__item-arrow${isRtl() ? '-rtl' : ''}"></span>`) : ''}
        ${languages && languages.length ? rowTpl(__('sm@_languages'), (`${mkTangText()}${languages.length > 1 ? `<span class="sm-landing-appstore-app-1-information__item-arrow${isRtl() ? '-rtl' : ''}"></span>` : ''}`)) : ''}

        ${date_updated_string ? rowTpl(__('sm@_Updated'), date_updated_string) : ''}
        ${content_rating ? rowTpl(__('sm@_age_rating'), content_rating) : ''}
        ${apple_watch ? rowTpl(__('sm@_apple_watch'), __('sm@_yes')) : ''}
        ${in_app_purchases ? rowTpl(__('sm@_in_app_purchases'), __('sm@_yes')) : ''}
      </div>
      <div class="sm-landing-appstore-app-1-information__list sm-landing-appstore-app-1-information__list--action">
        ${developer_website ? rowTplAction(__('sm@_developer_website'), iconWebsite) : ''}
        ${privacy_policy ? rowTplAction(__('sm@_privacy_policy'), iconPolicy) : ''}
        ${license_agreement ? rowTplAction(__('sm@_license_agreement'), iconLicense) : ''}
      </div>
    </div>
  `;
};

export default cmp(null, informationView);




// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-information/sm-landing-appstore-app-1-information.js